module.exports = __webpack_public_path__ + "static/emanagement1-9bab4e5cd3e2459d3817a3be4b668337.png";